import type { ExploreServer } from '@/types'

export const exploreServers: ExploreServer[] = [
  {
    id: 'exp1',
    name: 'Arcus Official',
    iconText: 'A',
    iconColor: '#3ECFCF',
    description: 'The official Arcus community server. Get help, share feedback, and connect with other privacy-focused users.',
    memberCount: 12400,
    onlineCount: 3200,
    tags: ['official', 'community', 'support'],
    category: 'technology',
    verified: true,
  },
  {
    id: 'exp2',
    name: 'Privacy Advocates',
    iconText: 'PA',
    iconColor: '#3ECF7B',
    description: 'Discussing digital privacy, security tools, encryption, and user rights in the modern internet.',
    memberCount: 8700,
    onlineCount: 1500,
    tags: ['privacy', 'encryption', 'security'],
    category: 'privacy',
    verified: false,
  },
  {
    id: 'exp3',
    name: 'Indie Game Dev',
    iconText: 'IG',
    iconColor: '#E8A840',
    description: 'A community for indie game developers. Share your projects, get feedback, find collaborators.',
    memberCount: 15200,
    onlineCount: 4100,
    tags: ['gamedev', 'indie', 'unity', 'godot'],
    category: 'gaming',
    verified: false,
  },
  {
    id: 'exp4',
    name: 'TypeScript Masters',
    iconText: 'TS',
    iconColor: '#3B82F6',
    description: 'Advanced TypeScript discussions, patterns, and help. From generics to type-level programming.',
    memberCount: 22000,
    onlineCount: 5600,
    tags: ['typescript', 'javascript', 'programming'],
    category: 'technology',
    verified: true,
  },
  {
    id: 'exp5',
    name: 'Pixel Art Corner',
    iconText: 'PX',
    iconColor: '#EC4899',
    description: 'Create and share pixel art. Weekly challenges, tutorials, and a friendly community for all skill levels.',
    memberCount: 6300,
    onlineCount: 890,
    tags: ['pixel-art', 'art', 'creative'],
    category: 'art',
    verified: false,
  },
  {
    id: 'exp6',
    name: 'Space Exploration',
    iconText: 'SE',
    iconColor: '#A855F7',
    description: 'Astronomy, astrophysics, space missions, and everything about the cosmos. NASA fans welcome!',
    memberCount: 11000,
    onlineCount: 2800,
    tags: ['space', 'astronomy', 'science', 'nasa'],
    category: 'science',
    verified: false,
  },
  {
    id: 'exp7',
    name: 'Rust Programming',
    iconText: 'RS',
    iconColor: '#E8A840',
    description: 'The unofficial Rust programming language community. Learn, share, and build with Rust.',
    memberCount: 31000,
    onlineCount: 7200,
    tags: ['rust', 'programming', 'systems'],
    category: 'technology',
    verified: true,
  },
  {
    id: 'exp8',
    name: 'Lo-Fi Beats',
    iconText: 'LF',
    iconColor: '#8B95A8',
    description: 'Chill lo-fi music community. Share beats, collaborate on tracks, or just hang out and listen.',
    memberCount: 9400,
    onlineCount: 2100,
    tags: ['music', 'lofi', 'beats', 'chill'],
    category: 'music',
    verified: false,
  },
  {
    id: 'exp9',
    name: 'Open Source Hub',
    iconText: 'OS',
    iconColor: '#3ECF7B',
    description: 'Connect with open source maintainers and contributors. Find projects, get code reviewed.',
    memberCount: 18500,
    onlineCount: 4300,
    tags: ['opensource', 'github', 'contributing'],
    category: 'technology',
    verified: false,
  },
  {
    id: 'exp10',
    name: 'Competitive FPS',
    iconText: 'CF',
    iconColor: '#CF3E4F',
    description: 'Competitive FPS gaming community. Valorant, CS2, Overwatch 2. Find teams and scrims.',
    memberCount: 27000,
    onlineCount: 8900,
    tags: ['fps', 'competitive', 'esports'],
    category: 'gaming',
    verified: true,
  },
  {
    id: 'exp11',
    name: 'Machine Learning Study',
    iconText: 'ML',
    iconColor: '#3B82F6',
    description: 'Study ML/AI together. Paper discussions, project showcases, beginner-friendly Q&A.',
    memberCount: 14200,
    onlineCount: 3100,
    tags: ['ml', 'ai', 'deeplearning', 'python'],
    category: 'education',
    verified: false,
  },
  {
    id: 'exp12',
    name: 'Crypto Privacy',
    iconText: 'CP',
    iconColor: '#A855F7',
    description: 'Privacy-preserving cryptocurrency and zero-knowledge proof discussions. Monero, ZCash, and more.',
    memberCount: 5800,
    onlineCount: 920,
    tags: ['crypto', 'privacy', 'zk-proofs'],
    category: 'privacy',
    verified: false,
  },
]
